"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SyndicationMatchActionStatus = exports.SyndicationMatchStatus = void 0;
var SyndicationMatchStatus;
(function (SyndicationMatchStatus) {
    SyndicationMatchStatus["Selected"] = "selected";
    SyndicationMatchStatus["Sent"] = "sent";
    SyndicationMatchStatus["Matched"] = "matched";
    SyndicationMatchStatus["NoMatched"] = "no_matched";
    SyndicationMatchStatus["TermSheetSigned"] = "term_sheet_signed";
    SyndicationMatchStatus["Closed"] = "closed";
    SyndicationMatchStatus["Failed"] = "failed";
    SyndicationMatchStatus["IntroNeedsApproval"] = "intro_needs_approval";
    SyndicationMatchStatus["Passed"] = "passed";
})(SyndicationMatchStatus = exports.SyndicationMatchStatus || (exports.SyndicationMatchStatus = {}));
var SyndicationMatchActionStatus;
(function (SyndicationMatchActionStatus) {
    SyndicationMatchActionStatus["Pending"] = "pending";
    SyndicationMatchActionStatus["Accepted"] = "accepted";
    SyndicationMatchActionStatus["Rejected"] = "rejected";
    SyndicationMatchActionStatus["Passed"] = "passed";
})(SyndicationMatchActionStatus = exports.SyndicationMatchActionStatus || (exports.SyndicationMatchActionStatus = {}));
//# sourceMappingURL=SyndicationMatch.js.map